import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Api from "./services/Api";
import WebConstant from "./WebConstant";
import { getCookie } from "./utility/WebAnalytic";
import DOMPurify from "dompurify";

const ExchangeTokenCSR = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	console.log("searchParams", searchParams);
	//const [authResponse, setAuthResponse] = React.useState(null);
	//const [destinationPage, setDestinationPage] = React.useState(null);

	useEffect(() => {
		const exchangeAuthCodeForToken = async () => {
			// Extract error and code from URL query parameters (similar to request.getParameter)
			console.log("exchange CSR token");
			const error = searchParams.get("error");
			const authCode = searchParams.get("code");
			const state = searchParams.get("state");
			const nonce = sessionStorage.getItem(WebConstant.NONCE);

			if (error) {
				console.error("Okta /authorize returns error:", error);
				Api.sendAuthError({ error: error });
				navigate("/login/error");
				return;
			}

			let DURL = sessionStorage.getItem(WebConstant.DURL);
			// Clear temporary storage

			sessionStorage.removeItem(WebConstant.NONCE);
			try {
				// Simulate the Okta token exchange by calling a backend API
				let request = {
					code: authCode,
					signOnPolicy: "CSR",
					nonce: nonce,
					// appId: Number(sessionStorage.getItem(WebConstant.SSO_APP_ID))
					//   ? Number(sessionStorage.getItem(WebConstant.SSO_APP_ID))
					//   : 466,
					//appId: 466,
				};
				if (DURL) {
					request.destinationUrl = DURL;
				}
				const authResponse = await Api.getSSOSession(request);
				if (!authResponse) {
					navigate("/login/error");
					return;
				}

				console.log("authResponse", authResponse);
				//setAuthResponse(authResponse);
				if (authResponse?.destinationUrl) {
					sessionStorage.setItem(WebConstant.DURL, authResponse.destinationUrl);
				}

				//Create cb_login cookie
				let domain = ".collegeboard.org";
				let cbLoginCookie = `cb_csr_login=${authResponse.unifiedSessionId}; Path=/; Secure; SameSite=Strict; domain=${domain}`;
				document.cookie = cbLoginCookie;

                let cbTreeEnvCookie = `${WebConstant.cbTreeEnvCookieName}=pine; Path=/; Secure; SameSite=Strict; domain=${domain}`;
				if (window.appConfig.envName !== "prod") {
                    cbTreeEnvCookie = `${WebConstant.cbTreeEnvCookieName}=${window.appConfig.envName}; Path=/; Secure; SameSite=Strict; domain=${domain}`;
                    let lowerEnvCookie = `lower_Env=${window.appConfig.envName}; Path=/; Secure; SameSite=Strict; domain=${domain}`;
                    document.cookie = lowerEnvCookie;
				}
                document.cookie = cbTreeEnvCookie;

				// Drop Web Analytics cookie
				dropWebAnalyticsCookie(authResponse, request.appId);

				let destination = authResponse.destinationUrl;

				//setDestinationPage(destination);
				if (!destination) {
					destination = WebConstant.defaultCsrDurl;
				}
				console.log("destination", destination);
				const sanitizedDURL = DOMPurify.sanitize(destination);
				window.location.href = sanitizedDURL;
			} catch (err) {
				console.error("Token exchange failed:", err);
				navigate("/login/error");
			}
		};

		exchangeAuthCodeForToken();
	}, []);

	function useSedWidget() {
		return true;
	}


	function dropWebAnalyticsCookie(authSessionInfo, appId) {
		// Extract namespace from authSessionInfo (assumed to be an object)
		const namespaceInLoginSession = authSessionInfo.namespace;
		let person = {
			accountId: authSessionInfo.accountId,
			oktaAccountId: authSessionInfo.oktaAccountId,
		};
		// const namespaceInLoginSession = "pf";
		// let person = {
		//   accountId: 123456,
		//   oktaAccountId: 123456,
		// };
		// Helper function to create cookie data (simulating WebAnaylyticsCookieManager.getCookie)
		const cookieValue = getCookie(
			person,
			namespaceInLoginSession.toLowerCase(),
			appId ? appId : 466
		);
		document.cookie = `iamkiwilog=${cookieValue}; domain=.collegeboard.org; max-age=300; Secure; SameSite=Strict; Path=/`;
	}
	// Render a loading state while the token exchange happens
	/* return (
	  <div>
		<h2>Done with exchangeToken...</h2>
		{authResponse && (
		  <div className="login-csr">
			<p>Debug only: authResponse: {authResponse.unifiedSessionId}</p>
			<p>Debug only: destination: {destinationPage}</p>
		  </div>
		)}
	  </div>
	); */

	return null;
};

export default ExchangeTokenCSR;
